import { combineReducers } from 'redux';
import isBootstrapped from './isBootstrapped';
import featureFlags from './featureFlags';
import error from './error';
import privacy from './privacy';
import analysis from './analysis';
import canonicalUrl from './canonicalUrl';
import analytics from './analytics';
import analyticsUserId from './analyticsUserId';
import identityReducer from './identity';
import optimization from './optimization';
import translationsReducer from './translations';
import requestMeta from './requestMeta';
import previewToken from './previewToken';
import location from './location';
import createReducer from '../../utils/createReducer';

const emptyReducer = createReducer(null, {});

export const stateReducer = combineReducers({
  analysis,
  analytics,
  analyticsUserId,
  canonicalUrl,
  error,
  isBootstrapped,
  privacy,
  ...translationsReducer,
  ...identityReducer,
  ...optimization,
  featureFlags,
  location,
  previewToken,
  requestMeta,
  session: emptyReducer,
});
